import React from 'react';
import { Moon, Sun } from 'lucide-react';

const ThemeToggle = ({ isDark, toggle }) => (
  <button 
    onClick={toggle}
    className={`relative w-14 h-7 rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${isDark ? 'bg-slate-700' : 'bg-slate-200'}`}
    aria-label="Toggle Dark Mode"
  >
    <div className={`absolute left-1 top-1 w-5 h-5 rounded-full transition-transform duration-300 flex items-center justify-center bg-white shadow-sm ${isDark ? 'translate-x-7' : 'translate-x-0'}`}>
      {isDark ? <Moon size={12} className="text-slate-800" /> : <Sun size={12} className="text-yellow-500" />}
    </div>
  </button>
);

export default ThemeToggle;
